/* ----- Splash timeline -----
   IntoSection holds for SPLASH_HOLD seconds, then fades out over SPLASH_FADE.
   Every other splash timer derives from these two, so the fade can never be
   cut off by the unmount and the cookie banner keeps its gap after it.
   To retime the intro, change SPLASH_HOLD and leave the rest alone. */
export const SPLASH_HOLD = 2.6
export const SPLASH_FADE = 1

export const SPLASH_COPY_DELAY = 0.3
export const SPLASH_COPY_FADE = 0.7

/* ms — splash unmounts once the fade has finished, plus a small buffer */
export const SPLASH_END_MS = (SPLASH_HOLD + SPLASH_FADE) * 1000 + 200
/* ms — cookie banner appears a second after the splash is gone */
export const COOKIES_DELAY_MS = SPLASH_END_MS + 1000
